import React from 'react';
import { Typography, TypographyProps, Skeleton } from '@mui/material';

interface LoadingTypographyProps extends TypographyProps {
    loading?: boolean;
    width?: number;
}

export const LoadingTypography: React.FC<React.PropsWithChildren<LoadingTypographyProps>> = ({
    loading,
    width,
    className,
    sx,
    ...props
}) => {
    if (loading) {
        return <Skeleton className={className} variant="text" width={width} sx={sx} />;
    }
    return <Typography className={className} {...props} />;
};
